var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoVanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 2.842H12.0527L13.9475 5.40369V9.15779H12.6622C12.5871 9.68471 12.3244 10.1669 11.9224 10.5157C11.5204 10.8644 11.006 11.0565 10.4738 11.0565C9.94154 11.0565 9.42717 10.8644 9.02515 10.5157C8.62312 10.1669 8.36045 9.68471 8.28537 9.15779H5.08326C5.00818 9.68471 4.7455 10.1669 4.34348 10.5157C3.94146 10.8644 3.42708 11.0565 2.89484 11.0565C2.3626 11.0565 1.84822 10.8644 1.4462 10.5157C1.04418 10.1669 0.781501 9.68471 0.706419 9.15779H0.0527344V1.57884C0.0527344 1.41134 0.119276 1.25069 0.23772 1.13225C0.356164 1.01381 0.516808 0.947266 0.684313 0.947266H9.52642C9.69392 0.947266 9.85457 1.01381 9.97301 1.13225C10.0915 1.25069 10.158 1.41134 10.158 1.57884V2.842ZM10.158 4.10516V5.9999H12.6843V5.8199L11.4161 4.10516H10.158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoVanIcon);
export default __webpack_public_path__ + "static/media/cargo-van-icon.246a9e356af69ddae7b1d4f81196d131.svg";
export { ForwardRef as ReactComponent };